import { showToast } from ".";
import Api from "../helpers/Api";
import _ from "lodash";
import {formatPhoneNumber} from '../helpers/Utils'

export const UPDATE_EXTERNAL_FEE_PAYMENT_REDUCER =
  "ExternalFeePayment/UPDATE_EXTERNAL_FEE_PAYMENT_REDUCER";
export const RESET_EXTERNAL_FEE_PAYMENT_REDUCER =
  "ExternalFeePayment/RESET_EXTERNAL_FEE_PAYMENT_REDUCER";

export const showLoader = (show) => async (dispatch) => {
  await dispatch({
    type: UPDATE_EXTERNAL_FEE_PAYMENT_REDUCER,
    payload: { isLoading: show },
  });
};

export const resetExternalFeePayment = () => async (dispatch) => {
  await dispatch({ type: RESET_EXTERNAL_FEE_PAYMENT_REDUCER });
};

export const getStudentMembershipId =
  (instituteId, studentPhone) => async (dispatch) => {
    await dispatch(showLoader(true));
    const response = await Api({
      method: "get",
      url: `/fees/get_students_membership_id?institute_id=${instituteId}&student_phone=${formatPhoneNumber(studentPhone)}`,
    })
    if (response.success) {
      await dispatch({
        type: UPDATE_EXTERNAL_FEE_PAYMENT_REDUCER,
        payload: {
          selectedStudentId: response.student_data.membership_id,
          instituteId: response.student_data.institute_id,
        },
      });
    }
    await dispatch(showLoader(false));
    if (response.message) {
      await dispatch(showToast(response.message));
    }
    return response;
  };

 export const createRazorpayOrder = (id, confirmationPaymentAmount) => async (dispatch, getState) =>
 {
  const { feeDues } = getState().student;
  const razorPaymentData = feeDues.filter((fee) => fee.payment);
  const response = await Api({
    method: 'post',
    url: '/fees/create_razorpay_order',
    data: {
      amount: confirmationPaymentAmount,
      student_id: id,
      razor_payment_data: JSON.stringify(razorPaymentData),
    }
  });
  return response;
 };

  export const captureRazorPayment =
    (responses, amount, date, id, institute_id) => async (dispatch, getState) => {
    const { feeDues } = getState().student;
    const razorPaymentData = feeDues.filter((fee) => fee.payment);
    const response = await Api({
      method: "post",
      url: "/fees/capture_razor_pay_payment",
      data: {
        student_id: id,
        amount: amount,
        payment_date: date,
        institute_id: institute_id,
        razorpay_payment_id: responses.razorpay_payment_id,
        razor_payment_data: JSON.stringify(razorPaymentData),
      },
    });
    if (response.success) {
      await dispatch({
        type: UPDATE_EXTERNAL_FEE_PAYMENT_REDUCER,
        payload: {
          feePaid: _.sortBy(response.fee_paid, ["payment_id"], ["asc"]),
          institute: response.institute,
          transactionId: response.transaction_id,
          paymentSuccessful: response.success,
        },
      });
      await dispatch(showToast("Payment is Successfull"));
    }
    return response;
    };

export const onPaymentFailure = (res, studentId, selectedPaymentDate) => async (dispatch, getState) => {
  const { feeDues } = getState().student;
  const razorPaymentData = feeDues.filter((fee) => fee.payment);
  const response = await Api({
    method: "post",
    url: "/fees/on_payment_failure",
    data: {
      payment_id: res.error.metadata.payment_id,
      student_id: studentId,
      payment_date: selectedPaymentDate,
      razor_payment_data: JSON.stringify(razorPaymentData),
    },
  });
  return response;
}; 
  
export const getStudentDetail = (studentID, instituteId) => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "post",
    url: `/fees/get_student_detail`,
    data: {
      student_id: studentID,
      institutes_id: instituteId,
    },
   })
    if (response.success) {
      await dispatch({
        type: UPDATE_EXTERNAL_FEE_PAYMENT_REDUCER,
        payload: {
          studentData: response.studentData,
          institute: response.institute,
          feeDues: response.fee_dues,
          feePaid: _.sortBy(response.fee_paid, ["payment_id"], ["asc"]),
          refundDetails: response.refund_details,
          totalFee: response.total_fee,
          feeAccounts: response.fee_accounts,
          institute: response.institute,
          unallocatedAmount: response.unallocated_amount
        },
      });
  };
  await dispatch(showLoader(false));
  if (!!response.message) {
    await dispatch(showToast(response.message));
  }
  return response;
};
